<template>
  <div class="mx-3">
    <v-row>
      <v-col
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <setup-separations-separation-types-dialog-create
          v-if="$hasPermissionTo(['create separation types'])"
          @created="loadData"
        />
      </v-col>
      <v-spacer />

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-select
          v-model="statusFilter"
          :items="items"
          item-text="state"
          item-value="value"
          label="Separation Type's Status"
          placeholder="Active / Deleted"
        />
      </v-col>

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-text-field
          v-model="search"
          placeholder="Key in separation type here"
          append-icon="search"
          label="Search Separation Types"
          hide-no-data
          hide-selected
        />
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="filteredSeparationTypes"
      :loading="tableLoading"
      :single-expand="true"
      :search="search"
      show-expand
    >
      <template v-slot:item="props">
        <tr>
          <td :class="props.isExpanded?'remove-bottom-border selected':'border-bottom'">
            <v-btn
              icon
              @click="props.expand(!props.isExpanded);loadSeparationReasons(props.item.id)"
            >
              <v-icon small> 
                {{ props.isExpanded ? 'fa-chevron-up':'fa-chevron-down' }} 
              </v-icon>
            </v-btn>
          </td>
          
          <td :class="props.isExpanded? 'remove-bottom-border selected':'border-bottom' ">
            <span>
              {{ props.item.name }}
            </span>
          </td>

          <td :class="props.isExpanded? 'remove-bottom-border selected':'border-bottom' ">
            <span v-if="statusFilter">
              <setup-separations-separation-types-dialog-edit
                v-if="$hasPermissionTo(['update separation types'])"
                :separation-type="props.item"
                @updated="loadData"
              />
              <span class="mx-1" />
              <setup-separations-separation-types-dialog-delete
                v-if="$hasPermissionTo(['delete separation types'])"
                :separation-type="props.item"
                @deleted="loadData"
              />
            </span>
            <span v-else>
              <setup-separations-separation-types-dialog-restore
                v-if="$hasPermissionTo(['restore separation types'])"
                :separation-type="props.item"
                @restored="loadData"
              />
            </span>
          </td>
        </tr>
      </template>

      <template v-slot:expanded-item="{ headers,item }">
        <td
          :colspan="headers.length"
          class="pb-2"
          style="background-color: rgba(0, 0, 0, .05);"
        >
          <setup-separations-separation-reasons-dialog-create
            v-if="$hasPermissionTo(['create separation types'])"
            :separation-type-id="item.id"
            @created="loadSeparationReasons(item.id)"
          />
          <v-data-table
            hide-default-footer
            style="border:1px solid #e6e6e6"
            dense
            class="mt-2"
            :items="separationReasons"
            :headers="separationReasonHeaders"
            :loading="separationReasonLoading"
            :items-per-page="-1"
          >
            <template v-slot:item.action="{ item }">
              <setup-separations-separation-reasons-dialog-edit
                v-if="$hasPermissionTo(['update separation types'])"
                :separation-reason="item"
                @updated="loadSeparationReasons(item.separation_type_id)"
              />
              <setup-separations-separation-reasons-dialog-delete
                v-if="$hasPermissionTo(['delete separation types'])"
                :separation-reason="item"
                @deleted="loadSeparationReasons(item.separation_type_id)"
              />
            </template>
          </v-data-table>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  export default {
    components: {
      SetupSeparationsSeparationTypesDialogCreate: () => import('@/components/hris/setup/separations/separation-types/DialogCreate'),
      SetupSeparationsSeparationTypesDialogEdit: () => import('@/components/hris/setup/separations/separation-types/DialogEdit'),
      SetupSeparationsSeparationTypesDialogDelete: () => import('@/components/hris/setup/separations/separation-types/DialogDelete'),
      SetupSeparationsSeparationTypesDialogRestore: () => import('@/components/hris/setup/separations/separation-types/DialogRestore'),
     
      SetupSeparationsSeparationReasonsDialogCreate: () => import('@/components/hris/setup/separations/separation-reasons/DialogCreate'),
      SetupSeparationsSeparationReasonsDialogEdit: () => import('@/components/hris/setup/separations/separation-reasons/DialogEdit'),
      SetupSeparationsSeparationReasonsDialogDelete: () => import('@/components/hris/setup/separations/separation-reasons/DialogDelete'),
    },
    data () {
      return {
        statusFilter: { state: 'Active', value: true },
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
        headers: [
          {
            text: 'Separation Type',
            align: 'left',
            value: 'name',
          },
          {
            text: '',
            sortable: false,
            align: 'center',
            value: 'action',
          },
        ],
        search: '',
        tableLoading: true,
        separationTypes: [],
        trashedSeparationTypes: [],
        separationReasonHeaders: [
          {
            text: 'Separation Reason',
            align: 'left',
            value: 'reason',
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
        separationReasonLoading: false,
        separationReasons: [],
      }
    },
    computed: {
      filteredSeparationTypes () {
        return this.statusFilter ? this.separationTypes : this.trashedSeparationTypes
      },
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        Promise.all([
          this.$api.hrisSeparationTypes().list(),
          this.$api.hrisSeparationTypes().listTrashed(),
        ]).then(([separationTypes, trashedSeparationTypes]) => {
          this.separationTypes = separationTypes.data
          this.trashedSeparationTypes = trashedSeparationTypes.data

          this.tableLoading = false
        })
      },

      loadSeparationReasons (separationTypeId) {
        this.separationReasonLoading = true

        this.$api.separationReasons().show(separationTypeId)
          .then(res => {
            this.separationReasons = _.orderBy(res.data, ['name'], ['asc'])

            this.separationReasonLoading = false
          })
      },
    },
  }
</script>

<style scoped>
.selected{
  background-color: rgba(0, 0, 0, .05);
}

.remove-bottom-border {
    border-bottom: 0px !important
}

.border-bottom {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important
}
</style>
